module.exports = __webpack_public_path__ + "html/wave-section-how-work_8c1581f1679fc01c8a8e47589666fd6c.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave/wave-section-how-work.html
// module id = 0qbV
// module chunks = 17